import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  debug: import.meta.env.DEV,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  ignoreErrors: [
    // Facebook in-app browser injects its own scripts that throw during page
    // unload when the backing Android Java bridge object is garbage-collected.
    "Error invoking postMessage: Java object is gone",
  ],
  denyUrls: [
    // Facebook in-app browser injected scripts (Android)
    /^iabjs:\/\//,
  ],
  // Capture 100% of transactions for performance monitoring
  tracesSampleRate: 1.0,
  // Capture 10% of sessions for replay
  replaysSessionSampleRate: 0.1,
  // Capture 100% of sessions with errors for replay
  replaysOnErrorSampleRate: 1.0,
});

export { Sentry };
